import React from "react";
import { useTranslation } from "react-i18next";
import ButtonHapticWrapper from "component/Button/ButtonHapticWrapper";
import { getBiometricIcon } from "../steps/passkey/icons";

type Props = {
    onOpenQrBackup?: () => void;
    onOpenPasskey?: () => void;
};

const BUTTON_CLASS = "h-10 px-4 rounded-xl bg-white/5 text-white/50 font-changa-one text-xs tracking-[0.12em] uppercase cursor-pointer hover:bg-white/10 transition-colors flex items-center justify-center gap-2 text-sm";

const QrIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="3" height="3" />
        <rect x="18" y="18" width="3" height="3" />
        <rect x="18" y="14" width="3" height="1" />
        <rect x="14" y="18" width="1" height="3" />
    </svg>
);

const MethodPicker = ({ onOpenQrBackup, onOpenPasskey }: Props) => {
    const { t } = useTranslation();

    if(!onOpenQrBackup && !onOpenPasskey) {
        return null;
    }

    return (
        <>
            <div className="w-full flex items-center gap-2 mt-1">
                <div className="flex-1 h-px bg-current opacity-15" />
                <span className="text-[9px] uppercase tracking-[0.15em] font-extrabold opacity-40">{t("signup.or")}</span>
                <div className="flex-1 h-px bg-current opacity-15" />
            </div>
            <div className="w-full flex flex-col gap-2">
                <div className="flex items-center gap-2">
                    {onOpenQrBackup && (
                        <ButtonHapticWrapper>
                            <button type="button" onClick={onOpenQrBackup} className={`${BUTTON_CLASS} flex-1`}>
                                <QrIcon />
                                {t("signup.qr_backup")}
                            </button>
                        </ButtonHapticWrapper>
                    )}
                    {onOpenPasskey && (
                        <ButtonHapticWrapper>
                            <button type="button" onClick={onOpenPasskey} className={`${BUTTON_CLASS} flex-1`}>
                                {getBiometricIcon().icon}
                                {getBiometricIcon().label}
                            </button>
                        </ButtonHapticWrapper>
                    )}
                </div>
            </div>
        </>
    );
};

export default MethodPicker;
